import React, {Fragment, useState} from "react";
import {INeedReaction} from "../../Notifications/DropdownNotifications/NeedReaction";
import {formatDateByLanguage} from "../../../utils/dateFormatter/dateFormatter";
import {Button} from "../../buttons";
import {setTemporaryNotifications} from "../../../redux/notifications/actions";
import {defaultNotificationCreator} from "../../../templates/Notifications";
import {tasksService} from "../../../api";
import {useAppDispatch, useAppSelector} from "../../../redux/hooks";
import url from "../../../utils/UrlHelper";
import Tooltip from "../../Tooltip/Tooltip";
import {t} from "i18next";
import {Link} from "react-router-dom";

interface IItem {
    productId: number,
    source: string,
    updatedAt: string
}

interface IImportConflictSourceDiffsResolveProps {
    taskId: number,
    data: INeedReaction,
}

const ImportProductsConflictSourceDiffsResolve: React.FC<IImportConflictSourceDiffsResolveProps> = ({taskId, data}) => {

    const dispatch = useAppDispatch();

    const [inProcessing, setInProcessing] = useState<boolean>(false)

    const { sellerId, userId } = useAppSelector(({ sellers, users }) => ({
        sellerId: sellers.currentSeller.info.data?.id,
        userId: users.currentUser.data.id
    }))

    function clickHandler(action: string) {
        setInProcessing(true)
        if (!sellerId || !userId) {
            return;
        }

        tasksService.doReaction(sellerId, taskId, 'hasSourceDiffs', action, {})
            .then(
                (res) => {
                    if (res.data.success) {
                        if (action === 'rewrite') {
                            dispatch(setTemporaryNotifications(
                                defaultNotificationCreator({
                                    title: "Задача на завершение импорта сформирована. Следите за прогрессом",
                                    description: "",
                                    iconType: "success"
                                })
                            ))
                        }
                        data.isReacted = true
                    }
                },
                (err) => {
                    dispatch(setTemporaryNotifications(
                        defaultNotificationCreator({
                            title: "Не удалось сформировать новую задачу",
                            description: err.message(),
                            iconType: "warning"
                        })
                    ))
                }
            )
            .catch((err) => {
                dispatch(setTemporaryNotifications(
                    defaultNotificationCreator({
                        title: "Не удалось сформировать новую задачу",
                        description: err.message,
                        iconType: "warning"
                    })
                ))
            })
            .finally(() => {
                setInProcessing(false)
            })
    }

    return (
        <div className="overflow-x-auto flex flex-col p-5 border border-c-gray dark:border-c-gray hover:border-c-blue dark:hover:border-white h-full">
            <h5 className={`font-semibold`}>В некоторые продукты в LK были внесены правки. Перезаписать их данными маркетплейса?</h5>
            <table className="table-auto w-full mb-2 mt-4">
                <thead className="text-xs uppercase text-gray-400">
                <tr className="">
                    <th className="pr-[20px]">
                        <div className="font-semibold text-left">Продукт</div>
                    </th>
                    <th className="pr-[20px]">
                        <div className="font-semibold text-left">Источник изменений</div>
                    </th>
                    <th className="">
                        <div className="font-semibold text-right">Дата изменения</div>
                    </th>
                </tr>
                </thead>
                <tbody className="text-sm">
                {data.data.map((v, key) => {

                    const item = v as IItem
                    return (
                        <tr key={key} className="border-b border-c-gray dark:border-c-gray py-2 ">
                            <td>
                                <Link target="_blank" className="font-medium text-indigo-500 hover:text-indigo-600" to={url(`/:sellerId/pim/edit/${item.productId}`, sellerId)}>{item.productId}</Link>
                            </td>
                            <td className="pr-[10px]">
                                {item.source}
                            </td>
                            <td className="py-3 whitespace-nowrap">
                                <div className="flex items-center justify-end">
                                    {formatDateByLanguage(new Date(item.updatedAt.replace(/-/g, "/")), "Pp")}
                                </div>
                            </td>
                        </tr>
                    )
                    }
                )}
                </tbody>
            </table>
            {!data.isReacted &&
                <div className={`flex`}>
                    <Button
                        appearance="tertiary"
                        size="sm"
                        customClassName="mr-2"
                        clickHandler={() => clickHandler('rewrite')}
                        loading={inProcessing}
                    >Да, перезаписать</Button>
                    <Button
                        appearance="tertiary"
                        size="sm"
                        customClassName="mr-2"
                        clickHandler={() => clickHandler('skip')}
                        loading={inProcessing}
                    >Нет, оставить без изменений</Button>
                </div>
            }
        </div>
    )

}

export default ImportProductsConflictSourceDiffsResolve;